import React, { useState } from "react";
// import ArtistForm from "../components/ArtistForm"; // Removed
import Footer from "../components/Footer";
import FAQ from "../components/FAQ";
import UserConsent from "../components/UserConsent";


import HeroSectionPartner from "../components/partnership/HeroSectionPartner";
import DistributeSectionPartner from "../components/partnership/DistributeSection";
import FeaturesSectionPartner from "../components/partnership/FeaturesSection";
import CreatorsSectionPartner from "../components/partnership/CreatorsSection";
import ProcessSectionPartner from "../components/partnership/ProcessSection";
import PartnerFormPopup from "../components/partnership/PartnerFormPopup";

function PartnershipPage() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const faqData = [
    {
      name: "1. What kind of content does Fawesome accept?",
      answer: "We accept movies, series, short films, documentaries, animation, and professionally produced creator content across all genres and languages.",
    },
    {
      name: "2. Is there any cost to distribute content on Fawesome?",
      answer: "No. There are no submission or distribution fees. Monetization is based on shared ad revenue.",
    },
    {
      name: "3. How do I earn revenue from my content?",
      answer: "You earn a share of advertising revenue based on your content’s viewership and ad impressions generated on our platform.",
    },
    {
      name: "4. How long does it take for content to go live?",
      answer: "Once onboarding is complete and your files meet delivery standards, content typically goes live within 5–10 working days.",
    },
    {
      name: "5. What video formats and specifications do you require?",
      answer: "We accept industry-standard HD MP4/H.264 files with stereo audio. Detailed specs will be shared during onboarding.",
    },
    {
      name: "6. Do I keep the rights to my content?",
      answer: "Yes. You retain full ownership. You only grant us non-exclusive streaming rights for distribution on Fawesome platforms.",
    },
    {
      name: "7. Which platforms will my content appear on?",
      answer: "Fawesome is available on 15+ platforms including Roku, Fire TV, Samsung TV, LG TV, iOS, Android, and web.",
    },
    {
      name: "8. How often will I receive performance reports and revenue statements?",
      answer: "You receive transparent performance analytics on a monthly basis and revenue statements 60 days following each calendar quarter.",
    },
    {
      name: "9. Do you have a minimum length or number of videos required?",
      answer: "No. We accept both single titles and full libraries, including short films and episodic content.",
    },
    {
      name: "10. How do I track how my content is performing on Fawesome?",
      answer: "You receive a monthly detailed report covering views, watch-time and impressions.",
    },
    {
      name: "11. Do you accept international content?",
      answer: "Yes. We distribute content from creators and studios worldwide.",
    },
    {
      name: "12. Does my content need subtitles?",
      answer: "Subtitles are recommended for better user engagement with our native US audience. It is thus mandatory for non-English titles, but not mandatory for English titles.",
    },
    {
      name: "13. Is my content exclusive to Fawesome?",
      answer: "No. All partnerships are non-exclusive unless mutually agreed otherwise.",
    },
    {
      name: "14. Can I remove my content later?",
      answer: "Yes. Your content can be removed based on notice periods outlined in the partnership agreement.",
    },
    {
      name: "15. How long is the typical partnership term?",
      answer: "Most agreements run on a yearly renewing basis with flexible exit options.",
    },
    {
      name: "16. Do you promote partner titles?",
      answer: "Select titles may receive promotional placement depending on performance, genre needs, and programming cycles.",
    },
    {
      name: "17. How secure is my content on the platform?",
      answer: "We use industry-standard DRM, secure hosting, and protected delivery workflows.",
    },
    {
      name: "18. Can YouTube creators distribute their existing videos here?",
      answer: "Yes, as long as you own full rights and the videos meet our quality standards.",
    },
    {
      name: "19. Do you accept 4K content?",
      answer: "Yes, but availability depends on platform support and internal programming decisions.",
    },
    {
      name: "20. Do you provide marketing assets or trailer guidelines?",
      answer: "Yes. Standard assets include poster, thumbnail, trailer, and metadata. Detailed guidelines are shared during onboarding.",
    },
  ];

  return (
    <>
      <HeroSectionPartner onCtaClick={togglePopup} />
      <DistributeSectionPartner />
      <FeaturesSectionPartner />
      <CreatorsSectionPartner />
      <ProcessSectionPartner />
      <FAQ data={faqData} deferRender={false} />
      <Footer></Footer>
      <UserConsent></UserConsent>

      <PartnerFormPopup isOpen={isPopupOpen} onClose={togglePopup} />
    </>
  );
}
export default PartnershipPage;
